import { Reveal } from "./motion";
import { useLang } from "@/i18n/LanguageContext";

export const Manifesto = () => {
  const { t } = useLang();
  const a = t.about;
  return (
    <section id="about" className="py-24 md:py-40 bg-white">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12">
        <Reveal className="max-w-4xl mb-20 md:mb-32">
          <div className="vw-eyebrow text-vw-green mb-6">{a.eyebrow}</div>
          <h2 className="font-serif text-4xl md:text-6xl !leading-[1.2] tracking-tight text-vw-ink text-balance">
            {a.hPre}
            <span className="italic font-light text-vw-green">{a.hEm}</span>
            {a.hPost}
          </h2>
        </Reveal>

        <div className="space-y-16 md:space-y-0">
          {a.chapters.map((c, i) => (
            <div
              key={i}
              className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-16 py-10 md:py-16 border-t border-vw-silver"
            >
              <Reveal className="md:col-span-4" delay={0.05}>
                <div className="font-serif text-6xl md:text-8xl text-vw-green/15 leading-none">
                  {String(i + 1).padStart(2, "0")}
                </div>
              </Reveal>
              <Reveal className="md:col-span-8 md:pl-8" delay={0.12}>
                <h3 className="font-serif text-2xl md:text-4xl text-vw-ink tracking-tight mb-5">
                  {c.title}
                </h3>
                <p className="text-lg text-vw-ink2 leading-relaxed max-w-2xl">{c.body}</p>
              </Reveal>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
